export class GetParamsRequest {
    constructor(deviceGuid: string) {
        this.DeviceGuid = deviceGuid;
    }

    DeviceGuid: string = "";
}

export class GetChannelParamsRequest {
    constructor(deviceGuid: string, channel: number) {
        this.DeviceGuid = deviceGuid;
        this.Channel = channel;
    }

    DeviceGuid: string = "";
    Channel: number = 0;
}